import { useTable } from "react-table";
import { format } from 'date-fns'

const Table = ({columns, data}) => {
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable({
            columns,
            data,
        });

    return (

        <table {...getTableProps()} className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-10">
            {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}
                            className="px-6 py-1 text-left text-20 font-medium text-gray-400 uppercase rounded-sm tracking-wider"
                        >
                            {column.render("header")}
                        </th>
                    ))}
                </tr>
            ))}
            </thead>
            <tbody {...getTableBodyProps()}
                   className="bg-white divide-y divide-gray-200">
            {rows.map((row, i) => {
                prepareRow(row);
                return (
                    <tr {...row.getRowProps()} className="hover:bg-gray-700 text-sm bg-[#202023] text-gray-400">
                        {row.cells.map((cell) => {
                            return <td {...cell.getCellProps()} className="px-6 py-2 whitespace-nowrap">
                                <a>
                                {cell.render("Cell")}
                                </a>
                            </td>
                        })}
                    </tr>
                );
            })}
            </tbody>
        </table>
    )
}

export default Table;